module.exports = __webpack_public_path__ + "526bc2d7264c2a3273f86f0226fef134.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/Foto_Manja_Herrmann-8513_klein.jpg
// module id = 463
// module chunks = 0